// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const fileRepositoryClient = createTypedClient();
export const createFileRepositoryClient = (config) => createTypedClient(config);
